import { IconProps } from '.';

export const CircularPulsingIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.5'>
        <circle cx='7.5' cy='7.5' r='1.5' fill={color} fillOpacity='0.96' />
      </g>
      <circle cx='7.5' cy='7.5' r='6.75' stroke={color} strokeOpacity='0.96' strokeWidth='1.5' />
      <circle cx='7.5' cy='7.5' r='1.5' fill={color} fillOpacity='0.96' />
    </svg>
  );
};
